import { api } from "./api";
import { decimalUnits, type Order, type ProcurementDocument } from "./procurement";

export interface OrderDifference {
  id: string; narudzba_id: string; stavka_id: string; primitak_id: string | null;
  vrsta: "manjak" | "osteceno" | "krivo" | "visak"; kolicina: string; opis: string | null;
  stanje: "otvorena" | "ceka" | "reklamirano" | "vraceno" | "rijeseno";
  rok: string | null; ishod: "stigao_ostatak" | "ne_treba" | "zadrzano" | "zamjena" | "odobrenje" | "odbijeno" | null;
  ishod_razlog: string | null; odobrenje_iznos: string | null; odobrenje_broj: string | null;
  vraceno_datum: string | null; vraceno_predao: string | null; otvorio_id: string;
  rijesio_id: string | null; rijeseno_at: string | null; created_at: string; updated_at: string;
  moze_rijesiti: boolean; dokumenti: (ProcurementDocument & { vrsta: "fotka" | "povratnica" })[];
}
export interface DifferenceAction {
  akcija: "ceka" | "ne_treba" | "zadrzano" | "vraceno" | "odobrenje" | "odbijeno" | "javljeno";
  rok?: string; razlog?: string; datum?: string; predao?: string; iznos?: string; broj?: string;
}
export interface DifferenceMail {
  from: string | null; to: string | null; cc: string[]; predmet: string; tekst: string;
  prilozi: { id: string; naziv: string; sha256: string }[];
  dostupan: boolean; razlog: string | null; pregled_token: string | null;
}
const path = (row: OrderDifference) => `/nabava/narudzbe/${row.narudzba_id}/razlike/${row.id}`;
export const differences = {
  action: async (row: OrderDifference, input: DifferenceAction, photo?: File) => {
    if (!photo) return (await api.post<OrderDifference>(`${path(row)}/akcija`, input)).data;
    const body = new FormData(); body.set("podaci", JSON.stringify(input)); body.set("povratnica", photo);
    return (await api.post<OrderDifference>(`${path(row)}/povrat`, body)).data;
  },
  preview: async (row: OrderDifference) => (await api.get<DifferenceMail>(`${path(row)}/mail-pregled`)).data,
  send: async (row: OrderDifference, pregled_token: string) => (await api.post<OrderDifference>(`${path(row)}/posalji`, { pregled_token })).data,
};
export const differenceNames = { manjak: "Fali", osteceno: "Oštećeno", krivo: "Krivo poslano", visak: "Višak" };
export const differenceStates = { otvorena: "Otvorena", ceka: "Čeka ostatak", reklamirano: "Reklamacija poslana", vraceno: "Vraćeno dobavljaču", rijeseno: "Riješeno" };
export const differenceOutcomes = { stigao_ostatak: "Stigao ostatak", ne_treba: "Ne treba više", zadrzano: "Zadržano", zamjena: "Stigla zamjena", odobrenje: "Knjižno odobrenje", odbijeno: "Dobavljač odbio" };
export const waivedOutcomes = ["ne_treba", "zadrzano", "odobrenje", "odbijeno"];
export function unitsString(value: bigint, digits = 3) {
  const raw = value.toString().padStart(digits + 1, "0");
  return `${raw.slice(0, -digits)}.${raw.slice(-digits)}`;
}
/** Quantity still receivable, including terminal outcomes that waive delivery. */
export function receivable(order: Order, item: Order["stavke"][number]) {
  const waived = (order.razlike || []).filter(row => row.stavka_id === (item.izvorna_stavka_id || item.id) && row.stanje === "rijeseno" && row.ishod && waivedOutcomes.includes(row.ishod)).reduce((sum, row) => sum + (decimalUnits(row.kolicina, 3) ?? 0n), 0n);
  const left = (decimalUnits(item.kolicina, 3) ?? 0n) - (decimalUnits(item.primljeno, 3) ?? 0n) - waived;
  return unitsString(left > 0n ? left : 0n);
}
